import "./login.styles.scss";
import Logo from "../../../../assets/images/BizinCLOUD Logo Main.png";
import heroImage from "../../../../assets/images/Inventory-img.png";
import { connect } from "react-redux";
import React, { Component } from "react";
import { ReactDOM } from "react";
import { Grid } from "@material-ui/core";
import { Form } from "../../../controls/useForm";
import useForm from "../../../../formData/useForm";
import validate from "../../../../formData/validate";
import Input from "../../../controls/Input/InputCompnent";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../controls/Input/form.styles.scss";
import Imagesign from "../../../../assets/images/Rectangle1.png";
import Button from "react-bootstrap/Button";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import usePasswordToggle from "./usePasswordToggle";
import Link from "react-router-dom";

const initialState = {
  passwords: {
    value: "",
    required: true,
  },
  email: {
    value: "",
    required: true,
  },
};

export const LoginPageComponent = ({
  LoginUser,
  triggerLogging,
  loginbuttonloader,
}) => {
  const eye = <FontAwesomeIcon icon={faEye} />;
  const [PasswordInputType, ToggleIcon] = usePasswordToggle();

  const { formData, errors, changeHandler, setErrors } = useForm(
    initialState,
    validate
  );
  const submitHandler = (e) => {
    e.preventDefault();

    var userDetails = {
      email: formData.email.value,
      password: formData.passwords.value,
    };
    LoginUser(userDetails);
  };

  return (
    <>
      {/* New Login */}
      <div className="w-screen h-screen sm:p-5 p-4">
        <div className="sm:grid-cols-2 mt-2 h-full grid top-5">
          {/* Image */}
          <div className="sm:flex w-[90%] hidden">
            <img
              src={heroImage}
              alt="Hero_Image"
              className="h-full rotate-50% transform -scale-x-100 w-full object-cover rounded-md"
            />
          </div>
          {/* End Image */}
          <div className="flex flex-col gap-3 sm:justify-center">
            <div className="">
              <img src={Logo} alt="Bizin_Cloud_Logo" className="w-16" />
            </div>
            <h3 className="font-bold">
              Welcome to BizinCloud, <br /> Sign In to Continue
            </h3>
            <p className="text-black text-lg">
              Don't Have An Account?{" "}
              <span className="font-bold underline">
                {" "}
                <a href="/user/register">Create Account</a>
              </span>{" "}
              <br /> It takes less than a minute
            </p>
            {/* Input Fields */}
            <ToastContainer />

            <div className="sm:w-4/5 relative">
              <Form onSubmit={submitHandler}>
                <Grid container>
                  <Input
                    label="Email*"
                    name="email"
                    placeholder="Enter your Email"
                    id="name"
                    className="w-full p-2"
                    value={formData.email.value}
                    onChange={changeHandler}
                    error={errors.email}
                  />
                  <div className="w-full relative">
                    <Input
                      label="Password*"
                      name="passwords"
                      placeholder="Enter your Password"
                      className="text-primary p-2"
                      id="password"
                      type={PasswordInputType}
                      value={formData.passwords.value}
                      onChange={changeHandler}
                      error={errors.passwords}
                    />
                    <span className="password-toggle-icon cursor-pointer absolute bottom-4 right-8">
                      {ToggleIcon}
                    </span>
                  </div>
                  {/* Forget Password */}
                  <div className="w-full  flex items-center justify-center">
                    <a
                      href="/user/forgotpassword"
                      className="text-blue-500 hover:underline text-center font-bold"
                    >
                      Forgot Password
                    </a>
                  </div>

                  <div className="w-full mt-5 px-2">
                    <button
                      className="bg-blue-500 border-none w-[98%] py-2 text-lg  text-white font-bold"
                      type="submit"
                    >
                      {" "}
                      Sign in{" "}
                      <i
                        className={
                          loginbuttonloader === true
                            ? "fa fa-spinner fa-spin"
                            : ""
                        }
                      ></i>
                    </button>
                  </div>
                  <div className="sm:grid sm:grid-cols-2 flex items-start flex-col mt-1"></div>
                </Grid>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    loading: state.userReducer.loader,
    user: state.userReducer.user,
    triggerLogging: state.userReducer.triggerLogging,
    loginbuttonloader: state.utilityReducer.loginbuttonloader,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoginUser(payload) {
    dispatch({ type: "LOGIN_USER", payload });
  },
  SetError() {
    dispatch({ type: "API_ERRORED" });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageComponent);
